// 载荷设置
export default {
    loadSetting: 'Load Setting',
    thrower: 'Thrower',
    searchlight: 'Searchlight',
    pager: 'Pager',
    descentRetarder: 'Descent retarder',
    loadType: '{0} Type',
    hangPoint: 'Hang Point',
    color: 'Color',
    default: 'default',
    blue: 'blue',
    yellow: 'yellow',
    grey: 'grey',
    purple: 'purple',
    name: 'Name',
    addPlaylist: 'Add to Playlist',
    device: 'Device',
    PTZCamera: 'PTZ camera',
    directShouting: 'Direct shouting',
    audioPlayback: 'Audio playback',
    playlist: 'playlist',
    previousSong: 'Previous song',
    next: 'Next',
    implement: 'Implement',
    stop: 'Stop',
    singlesPlaying: 'Singles playing',
    singleTuneCirculation: 'Single tune circulation',
    sequentialPlay: 'Sequential play',
    listLoop: 'List loop',
    loopPlayback: 'Loop Playback',
    open: 'Open',
    close: 'Close',
    meanwhile: 'Meanwhile',
    successively: 'Successively',
    interval: 'Interval',
    abnormalCommunication: 'Abnormal Communication',
    stow: 'Stow',
    putDown: 'Put Down',
    PTZLoad: 'PTZ load',
    PTZSetting: 'PTZ setting',
    camera: 'Camera',
    PTZManufacturer: 'PTZ Manufacturer',
    PTZType: 'PTZ Type',
    PTZModel: 'PTZ Model',
    courseLock: 'Course Lock',
    followMode: 'Follow Mode',
    centerCross: 'Center Cross',
    style: 'Style {0}',
    PTZCalibration: 'PTZ Calibration',
    startCalibration: 'Start Calibration',
    imagingMode: 'Imaging Mode',
    videoQuality: 'Video Quality',
    electronicAntiShake: 'Electronic anti shake',
    infraredStyle: 'Infrared Style',
    day: 'Day',
    night: 'Night',
    ordinary: 'Ordinary',
    difference: 'Difference',
    extremelyLow: 'Extremely low',
    low: 'Low',
    secondary: 'Secondary',
    high: 'High',
    veryHigh: 'Very high',
    turnOffAntiShake: 'Turn off anti shake',
    enableElectronicAntiShake: 'Enable electronic anti shake',
    turnOnOpticalAntiShake: 'Turn on optical anti shake',
    blackFever: 'Black fever',
    whiteFever: 'White fever',
    ferruginousRed: 'Ferruginous red',
    rainbow: 'Rainbow',
    lava: 'Lava',
    rainbowEnhancement: 'Rainbow enhancement',
    moltenMetal: 'Molten metal',
    bluishRed: 'Bluish red',
    amber: 'Amber',
    tip_err1: 'Audio format error, please upload again!',
    tip_err2: 'Audio size cannot exceed 10MB!',
    tip_err3: 'The file name can be up to 10 characters long. Please modify it and upload again!',
    tip_err4: 'Please select the audio to play',
    tip_err5: 'The file name can only contain Chinese, English and numbers!',
}